export const idx_data_bowler_hand = [];

idx_data_bowler_hand.push({
  hand: '',
  order_idx: -1,
});

idx_data_bowler_hand.push({
  hand: 'right_hander',
  order_idx: 0,
});

idx_data_bowler_hand.push({
  hand: 'left_hander',
  order_idx: 1,
});
